import {
  Mitarbeiter_DeleteRotationsplanMutation,
  Mitarbeiter_DeleteRotationsplanMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { DELETE_ROTATIONSPLAN } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteRotationsplan/mutation';
import { ROTATIONSPLAENE_BY_STANDORT_IDS } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplaene/graphql/queries';

export function useDeleteRotationsplan(standortIds: string[]) {
  const [execute, result] = useMutation<
    Mitarbeiter_DeleteRotationsplanMutation,
    Mitarbeiter_DeleteRotationsplanMutationVariables
  >(DELETE_ROTATIONSPLAN, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: ROTATIONSPLAENE_BY_STANDORT_IDS,
        variables: {
          standortIds,
        },
      },
    ],
  });

  const deleteRotationsplan = useCallback(
    (variables: Mitarbeiter_DeleteRotationsplanMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [deleteRotationsplan, result] as const;
}
